module.exports = __webpack_public_path__ + "img/nav_prev.292544fc.png";